export var promiseDeprecated = 'promiseDeprecated';
export var manualThrownError = 'manual thrown error';
export var promiseDeprecatedFromClonedModel = 'promiseDeprecatedFromClonedModel';
export var promiseTouchedByModel = Symbol('promiseTouchedByModel');
export var gluerUniqueFlagKey = Symbol('gluerUniqueFlagKey');
export var gluerUniqueFlagValue = Symbol('gluerUniqueFlagValue');
export var pureServiceKey = Symbol('pureService');
export var promiseDeprecatedFromLocalService = 'promiseDeprecatedFromLocalService';
export var promiseDeprecatedFromLocalServicePure = 'promiseDeprecatedFromLocalServicePure';
export var resolveCatchError = 'resolvePromiseCatchError';
export var underModelCallbackContext = 'underModelChangeContext';
export var defaultServiceOptions = {
  autoLoad: true
};
export var GlueConflictPolicy = {
  replace: 'replace',
  merge: 'merge'
};
export var defaultGlueConfig = {
  updatePolicy: GlueConflictPolicy.replace
};